import { useDispatch, useSelector } from "react-redux";
import InputAHSF from "../../../../Components/InputAHSF";
import { useEffect } from "react";
import { DetailsResearchSubmittedForAward } from "../../../../Redux/Reducers/Submitter/DetailsOfResearchSubmittedForAwardLastFiveYears";
import { useParams } from "react-router-dom";

const SummaryHeaderTable = (props) => {
  const dispatch = useDispatch();
   const {ApplicationInformationId} = useParams();
  const DetailsOfResearchSubmittedForAwardLastFiveYears = useSelector(
    (state) =>
      state.DetailsOfResearchSubmittedForAwardLastFiveYears
        .DetailsResearchSubmittedForAward
  );
  const refresh = useSelector(
    (state) =>
      state.refreshTableStatus.refreshTable["DetailsOfResearchSubmitted"]
  );

  const lang = useSelector((state) => state.languageReducer.Language);
  useEffect(() => {
    dispatch(
      DetailsResearchSubmittedForAward({
        applicationInformationId: localStorage.getItem(
          "ApplicationInformationId"
        )||
          ApplicationInformationId,
      })
    );
  }, [localStorage.getItem("ApplicationInformationId"),ApplicationInformationId ,refresh]);
  return (
    <>
      {DetailsOfResearchSubmittedForAwardLastFiveYears?.result ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            maxWidth: "100%",
            // marginTop: "20px",
          }}
        >
          <div
            style={{
              display: "flex",
              gap: "80px",
            }}
          >
            <InputAHSF
              fieldsName="NumberResearchPrincipalInvestigator"
              show={true}
              lang={lang}
              disabled={true}
              value={
                DetailsOfResearchSubmittedForAwardLastFiveYears?.result
                  ?.numberOfResearchPapersAddedAsPrincipalInvestigator
              }
              style={{
                width: "210px",
                textAlign: "center",
              }}
            />

            <InputAHSF
              fieldsName="NumberResearchCo_investigator"
              show={true}
              lang={lang}
              disabled={true}
              value={
                DetailsOfResearchSubmittedForAwardLastFiveYears?.result
                  ?.numberOfResearchPapersAddedAscoInvestigator
              }
              style={{
                width: "210px",
                textAlign: "center",
              }}
            />

            <InputAHSF
              fieldsName="NumberResearchCorrespondenceResearcher"
              show={true}
              lang={lang}
              disabled={true}
              value={
                DetailsOfResearchSubmittedForAwardLastFiveYears?.result
                  ?.numberOfResearchPapersAddedCorrespondenceResearcher
              }
              style={{
                width: "210px",
                textAlign: "center",
              }}
            />
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

export default SummaryHeaderTable;
